import { Icon } from '@iconify/react';
import { IconTiny } from '@/widgets/components/icon';
import DataUnavailableLight from '@/../img/placeholders/data-unavailable-light.svg';
import DataUnavailableStandard from '@/../img/placeholders/data-unavailable-standard.svg';
import React from 'react';
import styled from 'styled-components';

export const DEFAULT_CHART_BASE_TYPE = 'bar';
export const DEFAULT_CANVAS_INLINE_STYLES = {
  width: '100%',
};

export const DataUnavailableWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  height: 100%;
  width: fit-content;
`;

export const StyledDataUnavailableStandard = styled(DataUnavailableStandard)`
  width: 100%;
`;

export const StyledDataUnavailableLight = styled(DataUnavailableLight)`
  width: 100%;
`;

export const TmpPlaceholder = styled.div`
  height: 112px;
  margin-bottom: 0;
  padding-top: 22pcx;
  background-color: lightcyan;
`;

/* this is the top-right icon-button that enables card selection */
export const ActionIconButton = styled(Icon)`
  width: 14px;
  height: 14px;
  position: absolute;
  top: 19px;
  right: 19px;
  cursor: pointer;
`;

export const EllipsisIcon = styled(IconTiny)`
  color: 'rgba(0, 0, 0, 0.5)';
`;

export const BookedRatioLegendStyles = {
  BookedRatioLegend: styled.div`
    flex-direction: row;
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  LegendWrapper: styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    /* justify-content: center;
    align-items: center; */
    margin-bottom: ${(props) => (props.booked ? '60px' : 0)};
    margin-top: ${(props) => (props.booked ? 0 : '42px')};
  `,

  PercentageWrapper: styled.div`
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.83;
    letter-spacing: normal;
    color: ${(props) => props.color};
    display: flex;
    justify-content: ${(props) => (props.booked ? 'flex-end' : 'flex-start')};
    padding-right: ${(props) => (props.booked ? 0 : '20px')};
    padding-left: ${(props) => (props.booked ? '20px' : 0)};
  `,

  TitleWrapper: styled.div`
    font-size: 10px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #101938;
    white-space: nowrap;
    display: flex;
    justify-content: ${(props) => (props.booked ? 'flex-end' : 'flex-start')};
  `,
};

export const ChartTemplateParentComponent = styled.div`
  padding: 0;
  height: 100%;
  width: 100%;
`;

export const ChartSizer = styled.div`
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  height: ${(props) => (props.height ? `${props.height}px` : '100%')};
`;

export const StackedBookedRatioChartStyles = {
  ChartWrapper: styled.div`
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    width: 100%;
  `,
  HeaderWrapper: styled.div`
    width: 100%;
    height: 60px;
    padding: 0;
    display: flex;
    flex-direction: column;
  `,
  TitleWrapper: styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0;
  `,
  ChartBodyWrapper: styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

export const ChartLabelWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #101938;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
`;

export const TooltipRow = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export function ChartLabelItem({ color, text, circled = false }) {
  const LabelItemWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 14px;
    font-size: 12px;
    font-weight: 600;
  `;

  const ColorMarker = styled.div`
    width: 4px;
    height: ${(props) => (props.circled ? '4px' : '14px')};
    border-radius: ${(props) => (props.circled ? '50%' : '2px')};
    margin-right: 4px;
    background-color: ${(props) => props.color};

    display: flex;
    align-items: center;
  `;

  const LabelTextWrapper = styled.span`
    display: flex;
    align-items: center;
  `;

  return (
    <LabelItemWrapper>
      <ColorMarker color={color} circled={circled} />
      <LabelTextWrapper>{text}</LabelTextWrapper>
    </LabelItemWrapper>
  );
}
